<script setup lang="ts">
import { reactive } from "vue";
import StopInfoPipForm from "@/views/trips/components/forms/StopInfoPipForm.vue";
import { usePipStore } from "@/store/pip.store";
import type { StopInfoPipProps } from "@/types/props";
import type { Trip, TripRoute, TripRouteStop } from "@/types/trip";

defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    trip: Trip;
    route: TripRoute;
    stop: TripRouteStop;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const emit = defineEmits<{
  (e: "unload"): void;
}>();

const pipStore = usePipStore();

const pipProps = reactive<StopInfoPipProps>({
  get tripId() {
    return props.trip.id!;
  },
  get route() {
    return props.route;
  },
  get stop() {
    return props.stop;
  },
  title: "Verify information",
});

async function showUnloadVerification(): Promise<void> {
  await pipStore.open({
    component: StopInfoPipForm,
    props: pipProps,
    on: {
      save,
      close: () => pipStore.close(),
    },
  });
}

function save(): void {
  emit("unload");
}
</script>

<template>
  <v-btn
    :disabled="disabled"
    block
    class="text-uppercase font-weight-600"
    color="primary"
    v-bind="$attrs"
    variant="flat"
    @click="showUnloadVerification"
  >
    Unload and verify
  </v-btn>
</template>

<style lang="scss" scoped></style>
